/* eslint-disable import/no-named-as-default-member */
import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import axiosInstance from 'src/api/axiosInstance';
import { useLocation } from 'react-router';
// @mui
import Container from '@mui/material/Container';
// routes
import { paths } from 'src/routes/paths';

import { useSettingsContext } from 'src/components/settings';
import CustomBreadcrumbs from 'src/components/custom-breadcrumbs';
import BreadCrumbs from 'src/components/custom-breadcrumbs/breadcrumbs';
import { getCurrentProject, getCurrentServer, getMandEndPoint } from 'src/helper/server-address';
import useNavigateErrorHandler from 'src/hooks/useNavigateErrorHandler';
import { fetchEncryptedToken } from 'src/utils/encryptUtils';
// eslint-disable-next-line import/no-named-as-default
import CandidateNewEditForm from '../candidate-new-edit-form';

export default function CandidateDetailsView({ id, disabled }) {
  const token = sessionStorage.getItem('token');
  const settings = useSettingsContext();
  const [currentCand, setCurrentCand] = useState(null);
  const [currentCandPrefLoc, setCurrentCandPrefLoc] = useState([]);
  const [currentCandEduDtl, setCurrentCandEduDtl] = useState([]);
  const [currentCandSkils, setCurrentCandSkills] = useState([]);
  const [currentCandCertDtl, setCurrentCandCertDtl] = useState([]);
  const [currentCandExpDtl, setCurrentCandExpDtl] = useState([]);
  const [currentCandRefDtl, setCurrentCandRefDtl] = useState([]);
  const handleApiError = useNavigateErrorHandler();
  const currentCandView = true;
  const location = useLocation();
  const fromInterviewList = location.state?.fromInterviewList || false;

  const getCand = useCallback(async() => {
    const encryptedId = await fetchEncryptedToken(id, token);
    if (!encryptedId) throw new Error('Failed to encrypt ID');

    const apiUrl = `/rest/candidate/singleCandDetails/${encryptedId}`;
    axiosInstance
      .get(
        apiUrl,{
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => {
        setCurrentCand(res.data.candidate);
        setCurrentCandPrefLoc(res.data.preferredLocations);
        setCurrentCandEduDtl(res.data.educationDetails);
        setCurrentCandSkills(res.data.skillDetails);
        setCurrentCandExpDtl(res.data.expDetails);
        setCurrentCandCertDtl(res.data.certifications);
        setCurrentCandRefDtl(res.data.refDetails);
      }).catch((error)=>{
        handleApiError(error);
      })
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    setCurrentCand,
    setCurrentCandPrefLoc,
    setCurrentCandEduDtl,
    setCurrentCandSkills,
    setCurrentCandExpDtl,
    setCurrentCandCertDtl,
    setCurrentCandRefDtl,
    id,
    token,
  ]);

  useEffect(() => {
    getCand();
  }, [id, getCand]);

  return (
    <Container maxWidth={settings.themeStretch ? false : 'lg'}>
      <BreadCrumbs heading='View Candidate' />

      <CandidateNewEditForm
        currentCand={currentCand}
        currentCandPrefLoc={currentCandPrefLoc}
        currentCandEduDtl={currentCandEduDtl}
        currentCandSkils={currentCandSkils}
        currentCandCertDtl={currentCandCertDtl}
        currentCandExpDtl={currentCandExpDtl}
        currentCandRefDtl={currentCandRefDtl}
        currentCandView={currentCandView}
        disabled={disabled}
        fromInterviewList={fromInterviewList}
      />
    </Container>
  );
}
CandidateDetailsView.propTypes = {
  id: PropTypes.number,
  disabled: PropTypes.bool,
};
